/**
 * Returns true if the subject is a number
 * @param subject
 */
export default function isNumber(subject) {
    return typeof subject === 'number';
}
